import { CommonModule } from '@angular/common';
import { ChangeDetectionStrategy, Component, Input, OnInit, inject } from '@angular/core';
import { CarouselComponent } from '@client-ui/components/carousel/carousel.component';
import { Store } from '@ngrx/store';
import { HasCompanyClientUiSettingsDisabledDirective } from '@shared/directives/has-company-client-ui-settings-disabled.directive';
import { HasCompanyClientUiSettingsEnabledDirective } from '@shared/directives/has-company-client-ui-settings-enabled.directive';
import { BestBetterDeal, BestDealFlag } from '@shared/models/best-better-deal-view.model';
import { CompanyClientUISettingsKey } from '@shared/services/company-client-ui-settings.service';
import { selectBestBetterDealsByMortgageId } from '@shared/store/best-better-deals/best-better-deals.selectors';
import { Observable } from 'rxjs';
import { TicketContainerComponent } from '../ticket-container/ticket-container.component';

@Component({
  selector: 'cp-better-deal-ticket-carousel',
  imports: [
    CommonModule,
    TicketContainerComponent,
    CarouselComponent,
    HasCompanyClientUiSettingsEnabledDirective,
    HasCompanyClientUiSettingsDisabledDirective,
  ],
  templateUrl: './better-deal-ticket-carousel.component.html',
  styleUrl: './better-deal-ticket-carousel.component.scss',
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class BetterDealTicketCarouselComponent implements OnInit {
  @Input({ required: true }) mortgageId: string;
  private readonly globalStore = inject(Store);
  protected bestDeals$: Observable<BestBetterDeal[]>;
  BEST_DEAL_ICON_LABEL = BEST_DEAL_ICON_LABEL;

  protected readonly showOnlyBestDealInComparisonResultsKey: CompanyClientUISettingsKey = 'showOnlyBestDealInComparisonResults';

  ngOnInit(): void {
    this.bestDeals$ = this.globalStore.select(selectBestBetterDealsByMortgageId(this.mortgageId));
  }
}

const BEST_DEAL_ICON_LABEL = {
  [BestDealFlag.BIGGEST_STAVING]: {
    icon: 'star',
    label: 'BIGGEST SAVING',
  },
  [BestDealFlag.SAME_LENDER]: {
    icon: 'bank',
    label: 'SAME LENDER',
  },
  [BestDealFlag.LOWEST_PAYMENT]: {
    icon: 'lowest-payment',
    label: 'LOWEST PAYMENT',
  },
};
